<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9580_189539)">
      <path d="M10.6689 6.276L4.93095 12.014L3.98828 11.0713L9.72561 5.33333H4.66895V4H12.0023V11.3333H10.6689V6.276Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_9580_189539">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
